import React , {useEffect, useRef, useState} from 'react';
import {useField} from '@unform/core';

const Checkbox = ({name, label, help, ...rest}) => {
  const [checked, setChecked] = useState(false);
  const inputRef = useRef(null)
  const {fieldName, defaultValue, registerField, error} = useField(name)

  useEffect(()=>{
    registerField({
      name: fieldName,
      path: 'value',
      ref: inputRef.current,
    })
  },[fieldName, registerField])

  return (
    <div className="form-group form-check mt-20">
      <input
        id={fieldName}
        ref={inputRef}
        defaultValue={checked}
        type="checkbox"
        onChange={() => setChecked(!checked)}
        checked={checked}
        className={error ? 'form-check-input is-invalid': 'form-check-input'}
        {...rest}
      />
      <label class="form-check-label" for={fieldName}>{label}</label>
      {!!help
        ? error ? null : <small class="form-text text-warning">{help}</small>
        : null
      }
      
      {error && <span className="invalid-feedback">{error}</span>}
    </div>
  )
}
export default Checkbox;